import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/iconfont.css';
// 如果为真，则是运行于 electron 里面
var flag = window && window.process && window.process.versions && window.process.versions['electron'];
if(flag){
  const electron = window.require("electron");
  Vue.prototype.$electron = electron;
}

// function setRem() {
//   var whdef = 100 / 1920; // 表示1920的设计图,使用100PX的默认值
//   var bodyWidth = document.body.clientWidth; // 当前窗口的宽度
//   var rem = bodyWidth * whdef; // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
//   document.getElementsByTagName("html")[0].style.fontSize = rem + "px";
// }
// window.addEventListener("load", setRem);
// window.addEventListener("resize", setRem);
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
